module.exports = __webpack_public_path__ + "media/images/powerpoint/grands-moulins-de-paris-background-4c0924165d91f9ac338961413242d8f4.png";